import { type } from 'os'
import React, {useReducer} from 'react'
import { Action, KeyValuePayload } from '../../model'

const initialState = {
    token: '', profile: {}
}
  
const UserContext = React.createContext<any>(null)

const UserReducer = (state: any, action: Action<any>) => {
    switch(action.type){
        case 'set-property':
            return {...state, [action.payload.key]: action.payload.value}
        case 'clear-user-data':
            return {...initialState}
    }
}

export const UserProvider = (props: any) => {
    const [state, dispatch] = useReducer(UserReducer, {
       ...initialState
    })

    async function setUserProperty (key: string, value: any) {
        let val = typeof(value) === 'string' ? value : typeof(value) === 'number' ? String(value) : JSON.stringify(value)
        await dispatch({type: "set-property", payload: {key, value}})
        localStorage.setItem(key, val)
    }

    async function recoverUserData() {
        for (let item of Object.keys(initialState)) {
            let retrievedData = await localStorage.getItem(item)!
            retrievedData = ['number', 'string'].includes(typeof state[item]) ? retrievedData : ( !['null', 'undefined'].includes(retrievedData) ? JSON.parse(retrievedData): state[item])
            await setUserProperty(item, retrievedData)
        }
    }

    async function clearuserData() {
        await dispatch({type: "clear-user-data", payload: null})
    }

    const actions = {
        setUserProperty,
        recoverUserData,
        clearuserData
    }

    return (
        <UserContext.Provider value={{user: state, ...actions}} >
            {props.children}
        </UserContext.Provider>
    )
}

export default UserContext